var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.window
    ? _c(
        "div",
        { staticStyle: { cursor: "move" } },
        [
          _c(
            "b-row",
            {
              class:
                "col-lg-12 remove-window-spacing " +
                (_vm.showModal ? "window-width" : "window-widthfixed"),
            },
            [
              _c(
                "b-col",
                {
                  class: _vm.showModal ? "col-lg-4" : "col-lg-0",
                  staticStyle: { "padding-right": "0px !important" },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showModal,
                          expression: "showModal",
                        },
                      ],
                      staticClass: "notes_panel",
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "notes-panel-title" },
                        [
                          _c("fa", {
                            staticClass: "mr-1",
                            attrs: { icon: ["fas", "sticky-note"] },
                          }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Notes Template")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "scroll-Container" },
                        _vm._l(_vm.ansi_notes, function (element) {
                          return _c(
                            "b-row",
                            { key: element.id },
                            [
                              _c(
                                "b-col",
                                { staticClass: "my-1 mx-1" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      key: element.note,
                                      staticClass: "btn ansi-button text-left",
                                      attrs: {
                                        title: "Click to paste in Notes.",
                                        id: element.id,
                                        size: "sm",
                                        variant: "btn-primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.pushToNotes(element.note)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                * " +
                                          _vm._s(element.note) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  class: _vm.showModal ? "col-lg-8" : "col-lg-12",
                  staticStyle: { padding: "0" },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "panel",
                          attrs: { "header-class": "ansi-testing-header" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "6px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { flex: "1" } },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "btn greenBtn",
                                                attrs: {
                                                  id: "submitAnsiBtn",
                                                  size: "sm",
                                                  variant: "btn-primary",
                                                  block: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateSite()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Update\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { flex: "1" } },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "btn ansi-button",
                                                attrs: {
                                                  size: "sm",
                                                  variant: "btn-primary",
                                                  id: "togglePass",
                                                  block: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.togglePass()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Toggle Pass\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              flex: "none",
                                              display: "flex",
                                              "align-items": "center",
                                              "padding-left": "4px",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "close-icon-btn",
                                                attrs: {
                                                  type: "button",
                                                  title: "Close",
                                                  "aria-label": "Close",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.closeWindow()
                                                  },
                                                },
                                              },
                                              [
                                                _c("fa", {
                                                  attrs: {
                                                    icon: ["fas", "times"],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            343556345
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "info-grid mt-2" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "col-md-12 py-1 mx-3" },
                                [
                                  _c("b-col", { staticClass: "col-md-6" }, [
                                    _c("label", [
                                      _c("b", [_vm._v("SEGMENT ID: ")]),
                                      _vm._v(_vm._s(this.road_segment_id)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "col-md-6" }, [
                                    _c("label", [
                                      _c("b", [_vm._v("STATE: ")]),
                                      _vm._v(_vm._s(this.state_name)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "col-md-12 py-1 mx-3" },
                                [
                                  _c("b-col", { staticClass: "col-md-6" }, [
                                    _c("label", [
                                      _c("b", [_vm._v("TECHNICIAN: ")]),
                                      _vm._v(_vm._s(this.technician)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "col-md-6" }, [
                                    _c("label", [
                                      _c("b", [_vm._v("PART NUMBER: ")]),
                                      _vm._v(_vm._s(this.part_number)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.lane_number || _vm.lane_type
                                ? _c(
                                    "b-row",
                                    { staticClass: "col-md-12 py-1 mx-3" },
                                    [
                                      _vm.lane_number
                                        ? _c(
                                            "b-col",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c("label", [
                                                _c("b", [
                                                  _vm._v("LANE NUMBER: "),
                                                ]),
                                                _vm._v(
                                                  _vm._s(this.lane_number)
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.lane_type
                                        ? _c(
                                            "b-col",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c("label", [
                                                _c("b", [
                                                  _vm._v("LANE TYPE: "),
                                                ]),
                                                _vm._v(_vm._s(this.lane_type)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mx-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "notesRow" },
                                    [
                                      _c("label", { staticClass: "notes" }, [
                                        _vm._v("Notes"),
                                      ]),
                                      _vm._v(" "),
                                      _c("fa", {
                                        staticClass:
                                          "greenBtn testingWindowNotes",
                                        attrs: {
                                          size: "lg",
                                          title: "Open Notes Template",
                                          icon: ["fas", "angle-down"],
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showNotesModal()
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    ref: "notes",
                                    staticClass: "contenteditable-element",
                                    staticStyle: { resize: "none" },
                                    attrs: {
                                      id: "notes",
                                      rows: "4",
                                      cols: "50",
                                    },
                                    on: {
                                      mouseup: function ($event) {
                                        return _vm.enableInput($event)
                                      },
                                      mousedown: function ($event) {
                                        return _vm.enableInput($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.notes,
                                      callback: function ($$v) {
                                        _vm.notes = $$v
                                      },
                                      expression: "notes",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              staticClass: "boxed section-bar py-1 px-4 mt-2",
                              attrs: { "align-v": "center" },
                            },
                            [
                              _c("b-col", [
                                _c(
                                  "label",
                                  { staticClass: "section-title my-1" },
                                  [_vm._v("REQUIRED")]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "scroll-Container" },
                            _vm._l(_vm.ansiProperties, function (prop) {
                              return _c(
                                "b-row",
                                {
                                  key: prop.id,
                                  staticClass: "prop-row py-1 px-4 mt-2",
                                  attrs: { "align-h": "between" },
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p-2",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _c("span", { staticClass: "prop-name" }, [
                                        _c("strong", [
                                          _vm._v(_vm._s(prop.prop)),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { cols: "4" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "btn-group btn-group-toggle",
                                        attrs: { "data-toggle": "buttons" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            class:
                                              prop.value == "not_validated"
                                                ? "btn dashed-border grayBtn"
                                                : "btn dashed-border unSelectedIcons",
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: prop.prop,
                                                id: "option1",
                                                autocomplete: "off",
                                                value: "not_validated",
                                                title: "Not Validated",
                                              },
                                              domProps: {
                                                checked:
                                                  prop.value == "not_validated",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changed(
                                                    $event,
                                                    prop.prop
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-eye-close",
                                                attrs: {
                                                  title: "Not Validated",
                                                },
                                              },
                                              [
                                                _c("fa", {
                                                  attrs: {
                                                    icon: ["fas", "eye-slash"],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            class:
                                              prop.value == "indeterminate"
                                                ? "btn dashed-border yellowBtn"
                                                : "btn dashed-border unSelectedIcons",
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: prop.prop,
                                                id: "option2",
                                                autocomplete: "off",
                                                value: "indeterminate",
                                                title: "Indeterminate",
                                              },
                                              domProps: {
                                                checked:
                                                  prop.value == "indeterminate",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changed(
                                                    $event,
                                                    prop.prop
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-warning-sign",
                                                attrs: {
                                                  title: "Indeterminate",
                                                },
                                              },
                                              [
                                                _c("fa", {
                                                  attrs: {
                                                    icon: [
                                                      "fas",
                                                      "exclamation-triangle",
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            class:
                                              prop.value == "fail"
                                                ? "btn dashed-border redBtn"
                                                : "btn dashed-border unSelectedIcons",
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: prop.prop,
                                                id: "option3",
                                                autocomplete: "off",
                                                value: "fail",
                                                title: "Fail",
                                              },
                                              domProps: {
                                                checked: prop.value == "fail",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changed(
                                                    $event,
                                                    prop.prop
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-thumbs-down",
                                                attrs: { title: "Fail" },
                                              },
                                              [
                                                _c("fa", {
                                                  attrs: {
                                                    icon: [
                                                      "fas",
                                                      "thumbs-down",
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            class:
                                              prop.value == "pass"
                                                ? "btn dashed-border greenBtn"
                                                : "btn dashed-border unSelectedIcons",
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: prop.prop,
                                                id: "option4",
                                                autocomplete: "off",
                                                value: "pass",
                                                title: "Pass",
                                              },
                                              domProps: {
                                                checked: prop.value == "pass",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changed(
                                                    $event,
                                                    prop.prop
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-thumbs-up",
                                                attrs: { title: "Pass" },
                                              },
                                              [
                                                _c("fa", {
                                                  attrs: {
                                                    icon: ["fas", "thumbs-up"],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }